import React from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { portfolioCompanies } from "../data/mockData";
import "./CompanyDetail.css";

const CompanyDetail = () => {
  const { slug } = useParams();
  const company = portfolioCompanies.find((c) => c.slug === slug);

  if (!company) {
    return (
      <div className="company-detail-page">
        <section className="section-padding">
          <div className="container">
            <h1 className="hero-medium">Company not found</h1>
            <Link to="/portfolio" className="back-link body-regular">
              <ArrowLeft size={16} /> Back to Portfolio
            </Link>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="company-detail-page">
      <section className="section-padding">
        <div className="container">
          <Link to="/portfolio" className="back-link body-regular">
            <ArrowLeft size={16} /> Back to Portfolio
          </Link>

          <div className="company-header">
            <h1 className="hero-medium">{company.tagline}</h1>
            <span className="category-badge">{company.category}</span>
          </div>

          <p className="body-regular company-description">{company.description}</p>

          <div className="problem-solution">
            <div className="ps-block">
              <h3 className="heading-3">The Problem</h3>
              <p className="body-regular">{company.problem}</p>
            </div>
            <div className="ps-block">
              <h3 className="heading-3">Our Solution</h3>
              <p className="body-regular">{company.solution}</p>
            </div>
          </div>

          <div className="features-block">
            <h3 className="heading-3">Key Features</h3>
            <ul className="features-list">
              {company.features.map((feature, i) => (
                <li key={i} className="body-regular">{feature}</li>
              ))}
            </ul>
          </div>

          <div className="audience-block">
            <h3 className="heading-3">Who It's For</h3>
            <p className="body-regular">{company.audience}</p>
          </div>

          {company.extra && (
            <div className="extra-block">
              <h3 className="heading-3">{company.extra.title}</h3>
              <p className="body-regular">{company.extra.content}</p>
            </div>
          )}

          {company.link && (
            <a
              href={company.link}
              target="_blank"
              rel="noopener noreferrer"
              className="company-ext-link btn-primary"
            >
              Visit Site &rarr;
            </a>
          )}
        </div>
      </section>
    </div>
  );
};

export default CompanyDetail;
